import { render, staticRenderFns } from "./TheCorsi.vue?vue&type=template&id=aca7e236&scoped=true&"
import script from "./TheCorsi.vue?vue&type=script&lang=ts&"
export * from "./TheCorsi.vue?vue&type=script&lang=ts&"
import style0 from "./TheCorsi.vue?vue&type=style&index=0&id=aca7e236&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca7e236",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsSkeletonsTheCorsi: require('/usr/src/nuxt-app/components/elements/skeletons/TheCorsi.vue').default,ElementsTheError: require('/usr/src/nuxt-app/components/elements/TheError.vue').default})
